import { nodeDefinitions } from '../nodeDefinitions'
import { NodeDefinitions, ResolvedNodeDefinitions } from '../types'

/**
 * Resolves every registry entry once into a concrete registry: entries that are
 * async functions (they fetch data, e.g. customer custom-property keys) are
 * awaited; plain definitions pass through unchanged. Run once at load (see
 * `usePopulateResolvedNodeDefinitions`); the editor and watchtower then reason
 * over the resolved registry synchronously. A rejecting entry propagates — the
 * caller decides how to degrade.
 *
 * `registry` is injectable for testing; production callers use the default
 * static registry.
 */
export const resolveNodeDefinitions = async (
  registry: NodeDefinitions = nodeDefinitions
): Promise<ResolvedNodeDefinitions> =>
  Object.fromEntries(
    await Promise.all(
      Object.entries(registry).map(async ([type, entry]) => {
        const definition = typeof entry === 'function' ? await entry() : entry
        return [type, definition] as const
      })
    )
  ) as ResolvedNodeDefinitions
